/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 200);
/******/ })
/************************************************************************/
/******/ ({

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/m40/img/logo-title@2x.png";

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

var Loader, themes;

__webpack_require__(46);

themes = __webpack_require__(54);


/*
This sets up up all the data from the URLs query string
 */

Loader = (function() {
  function Loader() {
    var bgColor, gameCode, logo, primaryColor, themeCode;
    gameCode = UTIL.getQueryParam(['gamecode', 'gc']);
    themeCode = this.getTheme(gameCode);
    window.__themeCode = themeCode;
    window.__theme = __webpack_require__(51);
    window.__isMobile = this.isMobile(gameCode);
    window.__isTouch = this.isTouch();
    primaryColor = UTIL.hexToString(__theme.primaryColor);
    bgColor = UTIL.hexToString(__theme.bgColor);
    logo = __webpack_require__(13);
    this.themeLoader(__theme.title, logo, bgColor, primaryColor);
  }

  Loader.prototype.themeLoader = function(title, logo, bgColor, primaryColor) {
    logo = logo + "?v=" + window.__version;
    return document.addEventListener("DOMContentLoaded", function() {
      var className;
      document.title = title;
      className = __isMobile ? 'mobile' : 'desktop';
      document.body.classList.add(className);
      className = __isTouch ? 'touch' : 'mouse';
      document.body.classList.add(className);
      document.getElementById("logo").style.backgroundImage = "url(" + logo + ")";
      document.getElementById("initial-loader").style.backgroundColor = bgColor;
      document.getElementById("progress-bar").style.backgroundColor = primaryColor;
      return document.getElementById("progress-percent").style.color = primaryColor;
    });
  };

  Loader.prototype.getTheme = function(gameCode) {
    var gc, match, re, tc;
    for (gc in themes) {
      tc = themes[gc];
      re = new RegExp(gc, 'gi');
      match = gameCode.match(re);
      if (match != null) {
        return tc;
      }
    }
    return null;
  };

  Loader.prototype.isMobile = function(gameCode) {
    var check, isMobileGameCode;
    isMobileGameCode = gameCode.match(/_Mobile/);
    if (isMobileGameCode != null) {
      return true;
    }
    check = false;
    (function(a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
        check = true;
      }
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  };

  Loader.prototype.isTouch = function() {
    return 'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
  };

  return Loader;

})();

module.exports = new Loader();


/***/ }),

/***/ 46:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 51:
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/


module.exports = {
    title: "Mighty 40",
    theme: "m40",
    baseMultiplier: 1,
    maxPrize: 10,

    font: "ProximaNova",
    fontVariations: ":n4,n7",
    secondaryFont: "SignPainter",

    hasButtonImage: true,
    blurMenuBg: false,
    bigWinStartingPrizeId: 3,

    backgroundAnchorX: 0,
    backgroundAnchorY: 0.5,

    donePercent: 60,
    brushSize: 100,
    scratchY: 60,
    prizeTextY: 41,
    prizeScale: 1,

    showLogoInGame: true,
    logoYInGame: 10,
    logoYTitle: 140,
    logoZTitle: 0,
    logoFromBottomTitle: false,

    showCharacter: false,
    showFog: false,

    showBottomGradient: false,

    ticketIdX: 0,

    titleLossY: 215,

    winSign: 'movie',
    winSignTextY: 45,
    winSignTextMaxWidth: 220,
    winSignTextMaxFontSize: 50,
    winSignYOffset: 20,

    bgColor: 0xC8205C,
    primaryColor: 0xFD9309,

    images: {

        brush: "brush.png",

        bgs: {
            scratched: "scratch_bg.png",
            unscratched: "scratch.png"

        },

        prizes: {
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10"
        },
    },

    sounds: {
        volumes: {
            click: 0.3,
            music: 0.08,
            reveal: 0.5,
            bigWin: 0.4,
            win: 0.4,
            loss: 0.4
        },
        prizes: {
            1: "win-2",
            2: "win-3",
            3: "win-3",
            4: "win-3",
            5: "win-4",
            6: "win-4",
            7: "win-4",
            8: "win-4",
            9: "win-4",
            10: "win-4"
        }
    },

    styles: {
        prize: {
            fontFamily: "ProximaNova",
            fontSize: 17,
            fill: "#EEEEEE",
            align: "center",
            lineHeight: 25,
            stroke: '#000000',
            strokeThickness: 2,
            dropShadow: true ,
            dropShadowColor: '#000000',
            dropShadowAngle: Math.PI/2 ,
            dropShadowDistance: 1
        },
        maxPrize: {
            fontFamily: "ProximaNova",
            fontSize: 17,
            fill: "#FFB500",
            align: "center",
            lineHeight: 25,
            stroke: '#000000',
            strokeThickness: 2,
            dropShadow: true ,
            dropShadowColor: '#000000',
            dropShadowAngle: Math.PI/2 ,
            dropShadowDistance: 1
        },
        introText: {
            fontFamily: "ProximaNova",
            fontSize: 16,
            fill: "#FFFFFF",
            align: "center",
            lineHeight: 23,
            wordWrap: true,
            wordWrapWidth: 260,
            stroke: '#220b11',
            strokeThickness: 3,
            lineJoin: 'round',
            dropShadow: false,
            dropShadowBlur: 3,
            dropShadowColor: '#000000',
            dropShadowAngle: Math.PI/2,
            dropShadowDistance: 2
        }
    },

    positions: {
        points:[
            {
                x:0.23,
                y:0.20
            },
            {
                x:0.50,
                y:0.20
            },
            {
                x:0.77,
                y:0.20
            },
            {
                x:0.23,
                y:0.48
            },
            {
                x:0.50,
                y:0.48
            },
            {
                x:0.77,
                y:0.48
            },
            {
                x:0.23,
                y:0.76
            },
            {
                x:0.50,
                y:0.76
            },
            {
                x:0.77,
                y:0.76
            }
        ]
    }
};


/***/ }),

/***/ 54:
/***/ (function(module, exports) {

module.exports = {
	"FortyThieves": "40t",
	"HerosQuest": "hq",
	"HeroesQuest": "hq",
	"HerculesMagnus": "hm",
	"LuckyIrish": "li",
	"Mighty40": "m40",
	"MysticForce60_2": "mf2",
	"MysticForce": "mf",
	"DiscoDisco602": "dd2",
	"DiscoDisco": "dd"
};

/***/ })

/******/ });


// WEBPACK FOOTER //
// b-loader.js